export const openInNewTab = (url: string) => {
    // Open the URL in a new tab/window
    window.open(url, '_blank', 'noopener noreferrer');
};

export const openTwoTabs = (url1: string) => {
    const win1 = window.open('about:blank', '_blank')
    // const win2 = window.open('about:blank', '_blank')

    if (win1) win1.location.href = url1
    // if (win2) win2.location.href = url2
}

export const normalizeTime = (timestamp: number): string | undefined => {
    return getHumanTime(Date.now() - timestamp)
}
export const normalizeSide = (side: string): string => {
    // return side.toUpperCase() === 'BUY' ? 'купити' : 'продати'
    return side.toUpperCase() === 'BUY' ? 'КУПИТИ' : 'ПРОДАТИ'
}
export const getHumanTime = (time: number): string | undefined => {
    const seconds = ~~(time / 1000)
    const minutes = ~~(time / (1000 * 60))
    const hours = ~~(time / (1000 * 60 * 60))
    const days = ~~(time / (1000 * 60 * 60 * 24))
    if (time < 1000) {
        return `0s`
    }
    if (seconds < 60) {
        return `${seconds % 60}s`
    }
    if (minutes < 60) {
        return `${minutes}m ${seconds % 60}s`
    }

    if (hours < 24) {
        return `${hours}h ${minutes % 60}m`
    }

    if (days > 0) {
        return `${days}d`
    }
}

export function imageLink(symbolName: string) {
    // const IP = process.env.REACT_APP_ENV_MODE === 'prod' ? http_ip : process.env.REACT_APP_ENV_MODE === 'stage' ? stageIp : localhost
    try {
        if (symbolName.includes('-3') || symbolName.includes('-2') || symbolName.includes('-1')) {
            // return `http://${IP}/static/symbols/ADABULL.png`
            return `http://${window.location.host}/api/static/symbols/ADABULL.png`
        } else {
            // return `http://${IP}/static/symbols/${symbolName}.png`
            return `http://${window.location.host}/api/static/symbols/${symbolName}.png`
        }
    } catch (err) {
        console.log(err)
        // return `http://${IP}/static/symbols/ADABULL.png`
        return `http://${window.location.host}/api/static/symbols/ADABULL.png`
    }
}

export function imageLinkToEx(exchangeName: string) {
    // const IP = process.env.REACT_APP_ENV_MODE === 'prod' ? http_ip : process.env.REACT_APP_ENV_MODE === 'stage' ? stageIp : localhost
    // return `http://${IP}static/exchanges/${exchangeName}.png`
    return `http://${window.location.host}/static/exchanges/${exchangeName}.png`
}

export interface IStringIndexedObject<T> {
    [key: string]: T
}

export function makeQueryParamString(paramObject: IStringIndexedObject<number | string | boolean | undefined | string[] | object>) {
    return Object.entries(paramObject)
        .map(([key, value]) => {
            if (key && typeof value !== 'undefined') {
                // обʼєкт
                // масив
                if (Array.isArray(value)) {
                    return value.map(v => `${key}=${v}`).join('&')
                } else if (typeof value === 'object') {
                    let consume_string = ''
                    Object.entries(value).map(([key_2, value_2]) => {
                        // вкладений обʼєкт в обʼєкті
                        if (typeof value_2 === 'object') {
                            consume_string += Object.entries(value_2)
                                .map(([key_3, value_3]) => `${value_2}.${key_3}=${value_3}`)
                                .join('&')
                            // вкладений обʼєкт з масивом у значенні
                        } else if (Array.isArray(value_2)) {
                            return value_2.map(v => `${key}.${key_2}=${v}`).join('&')
                        } else {
                            consume_string += `${key}.${key_2}=${value_2}&`
                        }
                    })
                    return consume_string
                } else {
                    // простий тип
                    return `${key}=${value}`
                }
            } else {
                // undefined
                return ''
            }
        })
        .filter(Boolean)
        .join('&')
}

///* iPhone 15 */
// @media (min-width: 320px) and (max-width: 340px) {
//     html {
//       font-size: 12px;
//     }
//   }
//
//   /* iPhone 12 Mini, 13 */
//   @media (min-width: 330px) and (max-width: 350px) {
//     html {
//       font-size: 13px;
//     }
//   }
//
//   /* iPhone 11 Pro */
//   @media (min-width: 340px) and (max-width: 375px) {
//     html {
//       font-size: 14px;
//     }
//   }
//
//   /* iPhone 12, 13, 14 */
//   @media (min-width: 350px) and (max-width: 390px) {
//     html {
//       font-size: 15px;
//     }
//   }
//
//   /* iPhone 12 Pro Max, 14 Pro */
//   @media (min-width: 390px) and (max-width: 430px) {
//     html {
//       font-size: 16px;
//     }
//   }
//
//   /* iPhone 15 Pro, 16 */
//   @media (min-width: 400px) {
//     html {
//       font-size: 17px;
//     }

export const numToShortText = (num: number): string | number => {
    if (num > 999_999_999_999) {
        return `${Math.round(num / 1_000_000_000_000)}T`
    }
    if (num > 999_999_999) {
        return `${Math.round(num / 1_000_000_000)}B`
    }
    if (num > 999_999) {
        return `${Math.round(num / 1_000_000)}M`
    }
    if (num > 999) {
        return `${Math.round(num / 1_000)}k`
    }
    // if (num < 1000) {
    //   return `${num.toFixed(6)}`
    // }
    return num
}

export const AppText = {
    ua: {
        settings: {
            a: "ПІДСВІЧУВАТИ ВІД",
            b: "ВІДНЯТИ КОМІСІЮ",
            c: "ПРИХОВАТИ НИЖЧЕ",
            d: "ФІЛЬТРАЦІЯ",
            e: "ПРИХОВАТИ БІРЖІ",
            f: "ЗБЕРЕГТИ",
        },
        fav: {
            a: "ОБРАНЕ",
            b: "ВИДАЛЕНІ",
            c: "ПОРОЖНЬО"
        },
        menu: {
            a: "ТЕЛЕГРАМ",
            b: "ВЕБ-САЙТ",
            c: "СПОНСОРУВАТИ",
            d: "ПРОМОАКЦІЇ",
            e: "МОВА",
            f: "ЗАЛИШИТИ ВІДГУК",
            g: "УМОВИ ВИКОРИСТАННЯ",
        },
        details: {
            side_s: "ПРОДАТИ",
            side_b: "КУПИТИ",
            price: "ЦІНА",
            container: {
                change24: "ЗМІНА 24Г",
                vol24: "ОБʼЄМ 24Г",
                res_1: "ДОХІДНІСТЬ",
                res_2: "РЕЗУЛЬТАТ",
                min_vol: "МІН ОБʼЄМ",
                time: "ВІК СИГНАЛУ"
            }
        },
        info: {
            about: "ПРО TOF",
            about_a: "TOF(Trade Option Flow) — безкоштовний “радар” крос-біржових можливостей. Він у реальному часі аналізує 25 000+ ринків і показує, де ринок розходиться між біржами. Ви отримуєте короткий список того, що варто перевірити, і чіткі дані для рішення (ціни зі стакану та доступний обсяг). Щоб отримати результат, потрібен цикл з двох угод між двома біржами.",
            a: "ЩO ТАКЕ TOF І НАВІЩО ВІН МЕНІ?",
            a_a: "TOF(Trade Option Flow) — це інструмент для крос-біржової спотової торгівлі та моніторингу ринку. Він у реальному часі показує, де між двома біржами є різниця цін, яку можна перевірити та за потреби використати. Замість ручного перегляду десятків бірж і пар ви отримуєте короткий список того, що варто подивитися прямо зараз.",
            b: "ЯК САМЕ ЗАРОБИТИ ЧЕРЕЗ TOF?",
            b_b: "Прибуток можливий лише через цикл з двох дій: купити → продати (або продати → купити) між двома біржами. Якщо зробити тільки купівлю або тільки продаж — це вже звичайна позиція з очікуванням руху ціни. TOF створений для роботи з різницею цін у моменті, а не для довгого інвестування. \n Швидкий сценарій: сигнал → відкрити ТО → перевірити ціну й ОБ’ЄМ,$ → перейти на 2 біржі → купити на дешевшій і продати на дорожчій (або навпаки).",
            c: "ЩО Я БАЧУ В “ПОТОЦІ ТО” І ЩО ТАКЕ “ТО”?",
            c_c: "ТО(торгова опція) — це один сигнал по конкретній парі між двома біржами в певному напрямку “купити/продати”. Потік ТО — це стрічка таких сигналів у реальному часі. Одна й та сама пара може з’являтися знову, тому що ринок постійно змінюється: оновлюються ціни, обсяги та комбінації бірж.",
            d: "ЩО ОЗНАЧАЮТЬ “ДОХІДНІСТЬ, %” І “РЕЗУЛЬТАТ, $”?",
            d_d: "Дохідність, % — це відсоткова різниця цін на верхівці стакану (best bid/ask) між двома біржами в напрямку циклу. \nРезультат, $ — це грошова оцінка одного циклу “на цю секунду” з урахуванням доступного ОБ’ЄМ,$. Значення може бути як додатним, так і від’ємним. “+” означає, що цикл виглядає потенційно вигідним за поточними цінами, “−” — що за цих умов він виглядає збитковим.",
            e: "ЩО ТАКЕ “ОБ’ЄМ, $” І ЧОМУ ВІН ВАЖЛИВИЙ?",
            e_e: "ОБ’ЄМ, $ — це мінімальний доступний обсяг, який реально підтримується з обох сторін циклу за поточними найкращими цінами. Якщо спробувати виконати більше, ніж показано в ОБ’ЄМ,$, частина угоди може піти по гірших цінах (прослизання), і різниця цін може зникнути. Тому завжди важливо оцінювати дохідність разом із доступним обсягом.",
            f: "ЧОМУ “РЕЗУЛЬТАТ Є”, АЛЕ УГОДА НЕ ВИХОДИТЬ?",
            f_f: "Найчастіші причини: сигнал змінився за секунди, поки ви відкривали біржу; на найкращій ціні було мало ліквідності (“тонка верхівка”); ваш обсяг більший за доступний; комісії або реальний спред зменшили різницю; або існують обмеження біржі (мінімальний ордер, крок ціни тощо). TOF показує оцінку в моменті, але ринок рухається безперервно.",
            g: "ЩО ПОТРІБНО ДЛЯ ПОВНОЦІННОЇ РОБОТИ?",
            g_g: "Потрібні акаунти щонайменше на двох біржах із переліку, доступного в налаштуваннях TOF, а також баланс (наприклад, USDT) на цих біржах. Користувач сам відповідає за поповнення, перекази та розуміння базової механіки спотової торгівлі. Якщо акаунтів немає, TOF можна використовувати як безкоштовний інструмент моніторингу ринку без виконання угод.",
            h: "ЧИ ГАРАНТУЄ TOF ПРИБУТОК?",
            h_h: "Ні.TOF не є інвестиційною порадою і не гарантує результат. Він показує ринкову ситуацію “на зараз”, яка може змінитися за секунди. Результат залежить від швидкості виконання, обсягу, комісій, прослизання та умов конкретної біржі.",
        },
    },
    en: {
        settings: {
            a: "HIGHLIGHT FROM",
            b: "SUBSTRUCT FEE FROM",
            c: "HIDE LOWER THAN",
            d: "FILTER",
            e: "HIDE EXCHANGES",
            f: "APPLY",
        },
        fav: {
            a: "FAVORITE",
            b: "DELETED",
            c: "EMPTY"
        },
        menu: {
            a: "TELEGRAM",
            b: "WEB-SITE",
            c: "SUPPORT",
            d: "PROMO ACTIONS",
            e: "LANGUAGE",
            f: "GIVE FEEDBACK",
            g: "ACCEPTANCE OF TERMS",
        },
        details: {
            side_s: "SELL",
            side_b: "BUY",
            price: "PRICE",
            container: {
                change24: "CHANGE 24H",
                vol24: "VOLUME 24H",
                res_1: "PROFITABILITY",
                res_2: "PROFIT",
                min_vol: "MIN VOLUME",
                time: "TIME FROM ACTION"
            }
        },
        info: {
            about: "ABOUT TOF",
            about_a: "TOF (Trade Option Flow) is a free cross-exchange opportunity “radar.”\n" +
                " It analyzes 25,000+ markets in real time and shows where the market diverges between exchanges. You get a short list of situations worth checking and clear data for making a decision (order book prices and available volume).\n" +
                " To produce a result, a cycle of two trades between two exchanges is required.",
            a: "WHAT IS TOF AND WHY WOULD I NEED IT?",
            a_a: "TOF (Trade Option Flow) is a tool for cross-exchange spot trading and market monitoring. It shows in real time where price differences exist between two exchanges that can be verified and potentially used. Instead of manually scanning dozens of exchanges and trading pairs, you receive a short list of situations worth checking right now.",
            b: "HOW CAN YOU MAKE MONEY USING TOF?",
            b_b: "Profit is only possible through a two-step cycle:\n" +
                " buy → sell (or sell → buy) between two exchanges.\n" +
                "If you only buy or only sell, it becomes a normal market position that depends on future price movement. TOF is designed to work with price differences in the moment, not long-term investing.\n" +
                "Quick scenario:\n" +
                "signal → open TO → check price and Volume ($) → go to two exchanges → buy on the cheaper one and sell on the more expensive one (or vice versa).",
            c: "WHAT DO I SEE IN THE “TO FLOW” AND WHAT IS “TO”?",
            c_c: "A TO (Trading Option) is a single signal for a specific pair between two exchanges in a specific direction — buy/sell.\n" +
                "The TO Flow is a real-time stream of such signals. The same pair may appear repeatedly because the market constantly changes: prices, volumes, and exchange combinations update continuously.",
            d: "WHAT DO “PROFITABILITY, %” AND “RESULT, $” MEAN?",
            d_d: "Profitability (%) — the percentage price difference at the top of the order book (best bid/ask) between two exchanges in the direction of the cycle.\n" +
                "Result ($) — the estimated monetary outcome of one cycle at this moment, considering the available Volume ($).\n" +
                "The value can be positive or negative.\n" +
                "“+” means the cycle may look profitable under current prices,\n" +
                " “−” means it appears unprofitable under the current conditions.",
            e: "WHAT IS “VOLUME ($)” AND WHY IS IT IMPORTANT?",
            e_e: "Volume ($) represents the minimum available size currently supported on both sides of the cycle at the best prices.\n" +
                "If you attempt to execute a larger size than shown in Volume ($), part of the trade may execute at worse prices (slippage), and the price advantage may disappear.\n" +
                "That’s why profitability should always be evaluated together with the available volume.",
            f: "WHY DOES A “RESULT” APPEAR BUT THE TRADE DOESN’T WORK?",
            f_f: "Common reasons include:\n" +
                "• the signal changed within seconds while you were opening the exchange\n" +
                " • limited liquidity at the best price (“thin top of the book”)\n" +
                " • your order size exceeds available volume\n" +
                " • fees or the real spread reduce the difference\n" +
                " • exchange restrictions (minimum order size, tick size, etc.)\n" +
                "TOF shows the situation at the moment, but markets move continuously.",
            g: "WHAT IS REQUIRED FOR FULL USE?",
            g_g: "You need accounts on at least two exchanges from the list available in TOF settings, as well as balances (for example USDT) on those exchanges.\n" +
                "Users are responsible for funding their accounts, transfers, and understanding basic spot trading mechanics.\n" +
                "If you don’t have exchange accounts yet, TOF can still be used as a free market monitoring tool without executing trades.",
            h: "DOES TOF GUARANTEE PROFIT?",
            h_h: "No.\n" +
                "TOF is not investment advice and does not guarantee results. It shows the market situation at the current moment, which can change within seconds.\n" +
                "Actual results depend on:\n" +
                "• execution speed\n" +
                " • trade size\n" +
                " • fees\n" +
                " • slippage\n" +
                " • exchange conditions",
        },
    }
}